import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { formItem } from '../preview-forms.interface';

@Component({
    selector: 'app-form-fileupload',
    templateUrl: './form-fileupload.component.html',
    styleUrls: ['./form-fileupload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFileuploadComponent {
  form!: formItem;
  uploading = false;
  error = '';
  @Input('model') set item(v: formItem) { this.form = v; }

  @Output('update') update = new EventEmitter();
  @Output('valid') valid = new EventEmitter();

  constructor(private http: HttpClient) {}

  /** URL สำหรับแสดง/ดาวน์โหลดไฟล์ (path ที่เก็บเป็น relative ต้อง prepend apiURL) */
  get previewUrl(): string {
    const v = this.form?.answer_value;
    if (!v) return '';
    return /^https?:\/\//.test(v) ? v : `${environment.apiURL}${v}`;
  }

  /** ชื่อไฟล์เดิมของเอกสารที่แนบ — backend ห่อเอกสาร pdf/doc/docx/xls/xlsx เป็น .zip เสมอแล้วฝังชื่อเดิมไว้ในชื่อไฟล์ที่เก็บจริง
   *  (รูปแบบ "<guid>__<base64url ของชื่อเดิม>.zip" — เข้ารหัส base64url เพราะ backend validate answer_value ด้วย regex ที่ไม่รองรับเว้นวรรค/อักขระไทยตรงๆ)
   *  ถอดรหัสกลับจาก path ตรงๆ กันต้องเพิ่มคอลัมน์ DB ใหม่ — ใช้ได้ทั้งตอนอัปโหลดสดและตอนโหลดคำตอบเดิมซ้ำ (เช่น หน้าดูผลตอบกลับ) */
  get originalName(): string | null {
    const v = this.form?.answer_value;
    if (!v || !v.toLowerCase().endsWith('.zip')) return null;
    const filename = v.split('/').pop() || '';
    const sepIndex = filename.indexOf('__');
    if (sepIndex < 0) return null;
    const encoded = filename.slice(sepIndex + 2, filename.length - '.zip'.length);
    if (!encoded) return null;
    try {
      let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
      while (base64.length % 4) base64 += '=';
      const binary = atob(base64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      return new TextDecoder('utf-8').decode(bytes) || null;
    } catch {
      return null;
    }
  }

  /** คำตอบเป็นรูปภาพ (แสดง <img>) หรือเอกสารที่ถูกห่อเป็น .zip (แสดงเป็นลิงก์ดาวน์โหลด) */
  get isImageAnswer(): boolean {
    return !!this.form?.answer_value && !this.originalName;
  }

  onSelect(ev: any) {
    const file: File = ev?.target?.files?.[0];
    if (!file) return;
    this.error = '';
    if (file.size > 5 * 1024 * 1024) {
      this.error = 'ไฟล์ต้องไม่เกิน 5MB';
      ev.target.value = '';
      return;
    }
    const fd = new FormData();
    fd.append('file', file);
    this.uploading = true;
    this.http.post<any>('/api/Upload/answer', fd).subscribe({
      next: (res: any) => {
        const path = res?.data?.path ?? res?.path ?? '';
        this.form.answer_value = path;
        this.update.emit(path);
        if (path) this.valid.emit(false);
        this.uploading = false;
      },
      error: (err: any) => {
        this.error = err?.message || 'อัปโหลดไม่สำเร็จ กรุณาลองใหม่';
        this.uploading = false;
      }
    });
    ev.target.value = '';
  }

  removeFile() {
    this.form.answer_value = '';
    this.update.emit('');
    if (this.form.question_required) this.valid.emit(true);
  }
}
